import { useState, useEffect, React } from "react";
import { Form, Button, ButtonSet, TextInput, Grid, Column, FlexGrid, Row, IconButton, Loading, InlineNotification } from '@carbon/react';
import PerfilesTable from './PerfilesTable'
import { PerfilService } from '../../../../services'
import { Edit, TrashCan } from '@carbon/react/icons';
import Style from './PerfilesTab.module.scss';
import Cookies from "universal-cookie";


const TextInputIdProps = {
  id: 'Id',
  //labelText: 'Id',
  placeholder: 'Id',
  type: "number",
  maxLength: "20",
  disabled: true
};

const TextInputNameProps = {
  id: 'Nombre',
  labelText: 'Nombre',
  placeholder: 'Ingresa un nombre',
  type: "text",
  maxLength: "100"
};

const TextInputDescripcionProps = {
  id: 'Descripcion',
  labelText: 'Descripción',
  placeholder: 'Ingresa la descripción',
  type: "text",
  maxLength: "200"
};

const buttonEvents = {
  className: 'some-class'
};

export const PerfilesTab = () => {
  const cookies = new Cookies();

  const [perfiles, setPerfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [styleBox, setStyleBox] = useState(Style.hideBox);
  const [notificationKind, setNotificationKind] = useState('');
  const [notificationTitle, setNotificationTitle] = useState('');
  const [id, setId] = useState();
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [editar, setEditar] = useState(false);

  const[isbtnRegPerfilDisabled, setIsBtnRegPerfilDisabled] = useState(true);
  const[isAgregarPerfiles, setAgregarPerfiles] = useState(false);
  const[isModificarPerfiles, setModificarPerfiles] = useState(false);
  const[isEliminarPerfiles, setEliminarPerfiles] = useState(false);


  function limpiarFormulario() {
    setId('');
    setNombre('');
    setDescripcion('');
    setEditar(false);
    setIsBtnRegPerfilDisabled((isAgregarPerfiles)?false:true);
  }

  function consultarPerfiles() {
    setLoading(true);
    var cont = 0;
    PerfilService.consultarPerfiles().then((perfiles) => {
      var ArrayPerfiles = perfiles.map(obj => {
        var rObj = {};
        rObj["id"] = ++cont; //obj.PerfilPerfilId;
        rObj["nombre"] = obj.PerfilNombre;
        rObj["descripcion"] = obj.PerfilDesc;
        rObj["acciones"] = <> 
                              {(isModificarPerfiles &&
                                <IconButton kind="ghost" label="Editar" onClick={() => { editarPerfil(obj); }}> <Edit /> </IconButton>
                              )}
                              {(isEliminarPerfiles &&
                                <IconButton kind="ghost" label="Eliminar" onClick={() => { eliminar(obj); }}> <TrashCan /> </IconButton>
                              )}
                           </>;
        return rObj;
      }); 
      setPerfiles(ArrayPerfiles);
    }).finally(() => setLoading(false));
  }

  function validaPermisos() {
    let permisoPerfiles = cookies.get("modPerfiles");

    if(permisoPerfiles != undefined && permisoPerfiles.length > 0){
      const addPerfiles = (permisoPerfiles[0].PerfilModuloAgregar === 1)?true:false;
      setAgregarPerfiles(addPerfiles);
      setModificarPerfiles((permisoPerfiles[0].PerfilModuloModificar === 1)?true:false);   
      setEliminarPerfiles((permisoPerfiles[0].PerfilModuloEliminar === 1)?true:false);   
      setIsBtnRegPerfilDisabled((addPerfiles)?false:true);
    }
  }

  useEffect(() => {
    validaPermisos();
    //consultarPerfiles();
    
  }, []);

  function editarPerfil(obj) {
    setIsBtnRegPerfilDisabled(false);
    setId(obj.PerfilPerfilId);
    setNombre(obj.PerfilNombre);
    setDescripcion(obj.PerfilDesc);
    setEditar(true);
  }

  function eliminar(obj) {
    setLoading(true);
    const usuarioId = sessionStorage.getItem('usuarioId');
    let reqEliPerfil = {};
   
    reqEliPerfil.UsuarioId = usuarioId;
    reqEliPerfil.PerfilId = obj.PerfilPerfilId;
    PerfilService.eliminarPerfil(reqEliPerfil).then((data) => {
      consultarPerfiles();
      showNotification((data.Estatus == 0 )?'success':"error", data.Mensaje);
    }).catch(() => {
      setLoading(false);
      showNotification('error', 'Ocurrió un error al eliminar el perfil');
    }).finally(() => {
      setLoading(false);
    });
  }

  function showNotification(kind, msg) {
    setNotificationKind(kind);
    setNotificationTitle(msg);
    setStyleBox(Style.box);
    setTimeout(() => {
      setStyleBox(Style.hideBox)
    }, 5000);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const usuarioId = sessionStorage.getItem('usuarioId');
    let reqPerfil = {};
    
    let perfil = {
      PerfilNombre: nombre,
      PerfilDesc: descripcion
    };

    reqPerfil.UsuarioId = usuarioId;
    if (editar) {
      reqPerfil.SDTPerfil = [perfil];
      perfil.PerfilPerfilId = id;
      PerfilService.editarPerfil(reqPerfil).then((data) => {
        consultarPerfiles();
        //showNotification('success', 'El perfil se actualizó con éxito');
        showNotification((data.Estatus == 0 )?'success':"error", data.Mensaje);
      }).catch(() => {
        setLoading(false);
        showNotification('error', 'Ocurrió un error al actualizar el perfil');
      }).finally(() => {
        limpiarFormulario();
        setLoading(false);
      }); 
    } else { // Crear perfil
      if(isAgregarPerfiles){
        reqPerfil.SDTPerfilI = perfil;
        PerfilService.crearPerfil(reqPerfil).then((data) => {
          consultarPerfiles();
          limpiarFormulario();
          showNotification((data.estatus == 0 )?'success':"error", data.Mensaje);
        }).catch(() => {
          setLoading(false);
          showNotification('error', 'Ocurrió un error al crear el perfil');
        }).finally(() => {
          setLoading(false);
        });
      } else {
        showNotification('error', 'El usuario no tiene permiso para realizar esta acción.');
        setLoading(false);
      }
    }
  }
  return (
    <FlexGrid>
      <Loading className={'some-class'} active={loading} withOverlay={true} />
      <Row>
        <br />
        <Form aria-label="sample form" onSubmit={handleSubmit}>
          <TextInput hidden value={id} {...TextInputIdProps} />
          <Grid>
            <Column lg={4} md={4} sm={4}>
              <TextInput
                value={nombre}
                required
                onChange={(e) => setNombre(e.target.value)}
                {...TextInputNameProps} />
            </Column>
            <Column lg={8} md={8} sm={8}>
              <TextInput
                value={descripcion}
                required
                onChange={(e) => setDescripcion(e.target.value)}
                {...TextInputDescripcionProps} />
            </Column>
            <Column lg={2} md={4} sm={4}>  </Column>
            </Grid>
            <Grid>
                <Column lg={4} md={4} sm={4}>
                  <br />
                  <ButtonSet style={{width:125}}>
                    <Button id="btnLimpiar" kind="ghost" 
                            onClick={() => { limpiarFormulario() }}>
                      Limpiar
                    </Button>
                    &nbsp;
                    <Button id="btnBuscar" kind="secondary" 
                            onClick={() => { consultarPerfiles() }}>
                      Consultar
                    </Button>
                    &nbsp;
                    <Button type="submit" kind="primary" {...buttonEvents} 
                            id="btnRegPerfil" disabled={isbtnRegPerfilDisabled} >
                      {(!editar ? "Guardar" : "Actualizar")}
                    </Button>
                  </ButtonSet>
              </Column>
            </Grid>
        </Form>
      </Row>
      <br />
      <Row>
        <Grid>
          <Column lg={16} >
            <div className={styleBox}>
              <InlineNotification
                title={notificationTitle}
                kind={notificationKind}
                lowContrast={true} 
                hideCloseButton={true}
              />
            </div>
            <br />
            <PerfilesTable rows={perfiles} />
          </Column>
        </Grid>
      </Row>
    </FlexGrid>
  );
};